import { gql } from "@apollo/client";

const USLogout = gql`
  mutation USLogout {
    USLogout {
      result
    }
  }
`;

export default USLogout;
